<template>
	<div style="border-bottom: solid 1px #e9e9e9;margin-left: -20px; margin-right: -20px;">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CardSubHeader',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/Card/CardSubHeader.vue